import Text from "../../../../design-system/primitives/components/Text/Text";
import type { SparkChatSource } from "../types";
import { Sources } from "./Sources";
import styles from "./chatParts.css";

type MessageProps = { author: string; text: string };

export const paragraphsOf = (text: string) =>
  text
    .split(/\n+/)
    .map((p) => p.trim())
    .filter(Boolean);

const Message = ({ author, text }: MessageProps) => (
  <>
    <Text variant="label-small" color="neutral-100">
      {author}
    </Text>
    <div className={styles.messageBody}>
      {paragraphsOf(text).map((paragraph, i) => (
        <Text key={i} variant="body-small">
          {paragraph}
        </Text>
      ))}
    </div>
  </>
);

export const UserMessage = ({ text }: { text: string }) => (
  <div className={styles.message}>
    <Message author="Du" text={text} />
  </div>
);

type AssistantMessageProps = {
  text: string;
  sources?: SparkChatSource[];
};

export const AssistantMessage = ({
  text,
  sources = [],
}: AssistantMessageProps) => (
  <div className={styles.message}>
    <Message author="KI-Assistent" text={text} />
    <Sources sources={sources} />
  </div>
);

export const AssistantThinking = () => (
  <div className={styles.message} role="status">
    <Text variant="label-small" color="neutral-100">
      KI-Assistent schreibt …
    </Text>
  </div>
);
